import { AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode, AceProjektAceProjektEnumsAceProjektStatuscode, AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode, AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode, GlobalEnumsAcePortalstatus, GlobalEnumsAceTypphase, GutachtenDisplayModel, PhaseDisplayModel, ProjektberichtDisplayModel } from "@/api/model-index";
import { AbschnittDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model";
import { AnfrageDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model";
import { AnfrageListDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model";
import { GlobalEnumsAceXfoundportalobjekt } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt";
import { Injectable } from "@angular/core";
import { ItemContext } from "../models/itemcontext";
import { Subject } from "rxjs";
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
})
export class PortalContextService {

    protected itemContext: ItemContext;
    protected url: string;
    protected currentAnfrage: AnfrageDisplayModel;
    protected anfragen: AnfrageListDisplayModel[] | null;

    protected currentBericht: ProjektberichtDisplayModel | null;
    protected previousBericht: ProjektberichtDisplayModel | null;
    protected berichte: ProjektberichtDisplayModel[] | null;
    protected _berichtChanged = new Subject<ProjektberichtDisplayModel | null>();
    public BerichtChanged = this._berichtChanged.asObservable();

    protected currentGutachten: GutachtenDisplayModel | null;

    public isAnfrageDisabled(): boolean {
        if (this.isGutachten()) {
            return this.isGutachtenDisabled();
        }

        if (this.isBerichtsPhase())
            return !this.isBerichtOpen(this.currentBericht);

        return !this.isAnfrageInUeberarbeitung() && (this.isNotAntragsPhase() || !this.isAnfrageStatusGrundInEntwurf());
    }

    public isGutachten(): boolean {
        return this.currentGutachten != null;
    }

    public isGutachtenDisabled(): boolean {
        return this.currentGutachten && !(this.currentGutachten.statuscode == AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.inBearbeitung
            || this.currentGutachten.statuscode == AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.FreigegebenzurBegutachtung) || !this.isGutachtenNotExpired;
    }

    public get isGutachtenNotExpired(): boolean {
        if (this.currentGutachten && this.currentGutachten.ausschreibung?.fristFuerBegutachtung != null && Date.parse(this.currentGutachten.ausschreibung?.fristFuerBegutachtung) < Date.now()) {
            return false;
        }
        return true;
    }

    public isAnfrageStatusGrundInEntwurf() {
        return (this.CurrentAnfrage.objektTyp === GlobalEnumsAceXfoundportalobjekt.Projekt
            && this.CurrentAnfrage.projektStatus === AceProjektAceProjektEnumsAceProjektStatuscode.Entwurf)
            || (this.CurrentAnfrage.objektTyp === GlobalEnumsAceXfoundportalobjekt.Projektidee
                && this.CurrentAnfrage.projektStatus === AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Entwurf)

    }

    public isNotAntragsPhase(): boolean {
        return this.currentAnfrage?.portalStatus == GlobalEnumsAcePortalstatus.Ausschreibungabgelaufen
            || this.currentAnfrage?.portalStatus == GlobalEnumsAcePortalstatus.geschlossen
            || !this.isAnfrageInUeberarbeitung();
    }

    public isAnfrageInUeberarbeitung(): boolean {
        let inUeberarbeitung = this.currentAnfrage?.portalStatus == GlobalEnumsAcePortalstatus.inUberarbeitung
        let beforeUntil = ((this.currentAnfrage.freigegebenbis == null || (this.currentAnfrage.freigegebenbis != null 
            && moment(Date.now()).isSameOrBefore(moment(this.currentAnfrage.freigegebenbis), "day"))))
        let afterFrom = (this.CurrentAnfrage.freigegebenZurUeberarbeitung == null || (this.currentAnfrage.freigegebenZurUeberarbeitung != null 
            && (moment(Date.now()).isSameOrAfter(moment(this.currentAnfrage.freigegebenZurUeberarbeitung), "day"))))

        return inUeberarbeitung && beforeUntil  && afterFrom;
    }

    public isBerichtsPhase(): boolean {
        return this.currentAnfrage?.objektTyp == GlobalEnumsAceXfoundportalobjekt.Projekt && this.currentAnfrage?.phase?.typ == GlobalEnumsAceTypphase.Abschluss || this.currentAnfrage?.phase?.typ == GlobalEnumsAceTypphase.Bericht;
    }

    public isBerichtOpen(bericht: ProjektberichtDisplayModel | null): boolean {
        return bericht != null && bericht.status == AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.inBearbeitung;
    }

    public get CurrentAnfrage(): AnfrageDisplayModel {
        return this.currentAnfrage;
    }

    public set CurrentAnfrage(anfrage: AnfrageDisplayModel) {
        this.currentAnfrage = anfrage;
    }

    public get Anfragen(): AnfrageListDisplayModel[] | null {
        return this.anfragen;
    }

    public set Anfragen(value: AnfrageListDisplayModel[] | null) {
        this.anfragen = value;
    }

    public set CurrentGutachten(value: GutachtenDisplayModel | null) {
        this.currentGutachten = value;
    }

    public get CurrentGutachten(): GutachtenDisplayModel | null {
        return this.currentGutachten;
    }

    public get Abschnitte(): AbschnittDisplayModel[] | undefined | null {
        if (this.CurrentAnfrage) {
            if (this.currentBericht)
                return this.CurrentAnfrage.phase?.abschnitte?.find(abschnitt => abschnitt.id == this.currentBericht?.projektberichtId)?.abschnitte;
            if (this.currentGutachten && this.currentGutachten.gutachtenPhase)
                return this.currentGutachten.gutachtenPhase.abschnitte;
            else
                return this.CurrentAnfrage.phase?.abschnitte;
        }
        return [];
    }

    public get CurrentBericht(): ProjektberichtDisplayModel | null {
        return this.currentBericht;
    }

    public set CurrentBericht(bericht: ProjektberichtDisplayModel | null) {
        this.previousBericht = this.currentBericht;
        this.currentBericht = bericht;
        this._berichtChanged.next(bericht);
    }

    public get PreviousBericht(): ProjektberichtDisplayModel | null {
        return this.previousBericht;
    }

    public get Berichte(): ProjektberichtDisplayModel[] | null {
        return this.berichte;
    }

    public set Berichte(value: ProjektberichtDisplayModel[] | null) {
        this.berichte = value;
    }

    public get CurrentItemContext(): ItemContext {
        if (this.url) {
            this.url = decodeURIComponent(this.url);
            const urlSegments = this.url.split('/');
            let scope: number = urlSegments[3] as unknown as number;
            let id: string = urlSegments[4];

            if (this.itemContext && this.itemContext.id && this.itemContext.id === id && this.itemContext.type) {
                return this.itemContext;
            }
            //const ctxType: GlobalEnumsAceXfoundportalobjekt = GlobalEnumsAceXfoundportalobjekt[scope] as unknown as GlobalEnumsAceXfoundportalobjekt;

            this.itemContext = new ItemContext();
            if (scope && GlobalEnumsAceXfoundportalobjekt.getAsDataset().find(x => x.Value == scope)) {
                this.itemContext.id = id;
                this.itemContext.type = scope;
            }
            else {
                this.setItemContextExternal();
            }
        }

        return this.itemContext;
    }

    public get Url(): string {
        return this.url;
    }

    public setUrl(url: string) {
        this.url = url;
    }

    public setItemContextExternal() {
        // Ovverride in inherited service to set additional types
        // if(this.currentAnfrage){
        //     this.itemContext.id = this.currentAnfrage.id;
        //     this.itemContext.type = this.currentAnfrage.objektTyp || 0;
        // }
    }

    public get isReviewInBegutachtungsFrist(): boolean {
        return (this.currentGutachten?.ausschreibung?.fristFuerBegutachtung != null
            && Date.parse(this.currentGutachten?.ausschreibung?.fristFuerBegutachtung) > Date.now())
            && this.currentGutachten?.statuscode != AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.Abgegeben;
    }

    public get currentPhase(): PhaseDisplayModel | undefined{
        return this.CurrentGutachten?.gutachtenPhase ?? this.CurrentAnfrage.phase;
      }
}
